import { http } from "./config";
import authHeader from "./auth-header";

export default {
  consultarLtv: (contrato) => {
    return http.get("/api/cliente/ltv", {
      params: {
        contrato,
      },
      headers: authHeader(),
    });
  },
};
